import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { About } from "./pages/About";
import { CurrentListings } from "./pages/CurrentListings";
import { DreamHome } from "./pages/DreamHome";
import { Home } from "./pages/Home";
import { MlsListings } from "./pages/MlsListings";
import { OpenHouses } from "./pages/OpenHouses";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfUse } from "./pages/TermsOfUse";
export function App() {
  useEffect(() => {
    document.title = "Teri Britton Real Estate of Florida";
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="31b8l22qjqjbb">
      <Routes data-id="element-1" data-mp="31bs09botatln">
        <Route path="/" element={<Home data-id="element-3" data-mp="31ctbbg5tvg3d" />} data-id="element-2" data-mp="31c9vq63nh3si" />
        <Route path="/about" element={<About data-id="element-5" data-mp="2wjqkvgwckmre" />} data-id="element-4" data-mp="2wk06yte9u9rt" />
        <Route path="/dream-home" element={<DreamHome data-id="element-7" data-mp="2wi5mfg6wwjo9" />} data-id="element-6" data-mp="2wiff5bjcd4xn" />
        <Route path="/mls-listings" element={<MlsListings data-id="element-9" data-mp="28t4jg8gum0qd" />} data-id="element-8" data-mp="28tw5osok2m3z" />
        <Route path="/current-listings" element={<CurrentListings data-id="element-11" data-mp="23vul23bheeqe" />} data-id="element-10" data-mp="28sbad0uf2z52" />
        <Route path="/open-houses" element={<OpenHouses data-id="element-13" data-mp="23ti6m04xmmi3" />} data-id="element-12" data-mp="23utcc5hxu4bu" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-15" data-mp="3ijfvu1ti80fo" />} data-id="element-14" data-mp="3ikh829m9asyz" />
        <Route path="/terms-of-use" element={<TermsOfUse data-id="element-17" data-mp="3ml17jjuay8oa" />} data-id="element-16" data-mp="3ii4sg33z0up3" />
      </Routes>
    </BrowserRouter>;
}